module.exports = __webpack_public_path__ + "img/sfondo-petto-di-pollo.e3909c1e.png";